import { render, staticRenderFns } from "./HowToDeliver.vue?vue&type=template&id=1d6e8368&"
import script from "./HowToDeliver.vue?vue&type=script&lang=js&"
export * from "./HowToDeliver.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports